export default __webpack_public_path__ + "static/media/11 POR EL HUECO DEL MUNDO.5cb7344b.png";